<template>
    <div>
        ABSTRACT REPORT GENERAL
    </div>
</template>